<template>
    <div class="row" id="step-2">
        <div class="col-sm-12 col-md-6">
            <div class="row form-section-header my-3">
                <div class="col-12">
                    <h4 class="form-section-header-title">{{ $t('Registreerin') }}</h4>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-12">
                    <button class="btn btn-light mx-2" :disabled="!self || isAdded(self.id) || !canAddMoreParticipants()" v-on:click="addSelf()">
                        {{ $t('Registreerin iseenda') }}
                    </button>
                    <button class="btn btn-light mx-2" :disabled="!canAddMoreParticipants()" v-on:click="addNew()">
                        {{ $t('Registreerin kellegi teise') }}
                    </button>
                </div>
            </div>

            <div class="row my-3 ml-1" v-if="participants.length > 0">
                <div class="col-12 p-0">
                    <div class="accordion">
                        <div class="card" v-for="p in participants">
                            <div class="card-header" :id="'prtH-' + p.id" v-on:click="toggle(p.id)">
                                <h6 class="tab-title mb-0">
                                    {{ $t('Osavõtja') }}
                                    <em v-if="p.id === self.id" class="em">(Mina)</em>
                                    <span v-else-if="p.firstname">({{ p.firstname }} {{ p.lastname }})</span>
                                </h6>
                            </div>

                            <div :id="'prtD-' + p.id" class="collapse" :class="{show: p.$active}" v-bind:aria-labelledby="'prtH-' + p.id">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 form p-md-0">
                                            <form action="#">
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Eesnimi') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('firstname')}"
                                                               :required="p.$form.isRequired('firstname')"
                                                               type="text"
                                                               v-model="p.firstname">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('firstname')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Perekonnanimi') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('lastname')}"
                                                               :required="p.$form.isRequired('lastname')"
                                                               type="text"
                                                               v-model="p.lastname">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('lastname')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Sugu') }}</label>
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio my-1"
                                                                 v-for="(v,k) in p.$form.fields.gender._choices" :value="k">
                                                                <input class="custom-control-input"
                                                                       type="radio"
                                                                       :id="'gender-' + p.id + k"
                                                                       :key="'gender-' + p.id"
                                                                       :class="{'is-invalid': p.$form.hasErrors('gender')}"
                                                                       :required="p.$form.isRequired('gender')"
                                                                       v-model="p.gender"
                                                                       :value="k">
                                                                <label class="custom-control-label" :for="'gender-' + p.id + k">
                                                                    {{ v }}
                                                                </label>
                                                            </div>
                                                            <div class="invalid-feedback" v-for="error in p.$form.getErrors('gender')">
                                                                <div class="alert alert-danger">{{ error }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Sünniaasta') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('birthyear')}"
                                                               :required="p.$form.isRequired('birthyear')"
                                                               type="number"
                                                               min="1900"
                                                               max="2030"
                                                               v-model="p.birthyear">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('birthyear')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('E-post') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('email')}"
                                                               :required="p.$form.isRequired('email')"
                                                               :disabled="p.id === self.id"
                                                               type="email"
                                                               v-model="p.email">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('email')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_phone">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Telefon') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('phone')}"
                                                               :required="p.$form.isRequired('phone')"
                                                               type="text"
                                                               v-model="p.phone">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('phone')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_address">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Tänav, maja ja korteri nr') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('address.address')}"
                                                               :required="p.$form.isRequired('address.address')"
                                                               type="text"
                                                               v-model="p.address.address">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('address.address')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_address">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Linn/asula') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('address.city')}"
                                                               :required="p.$form.isRequired('address.city')"
                                                               type="text"
                                                               v-model="p.address.city">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('address.city')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_address">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Maakond') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('address.county')}"
                                                               :required="p.$form.isRequired('address.county')"
                                                               type="text"
                                                               v-model="p.address.county">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('address.county')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_address">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Indeks') }}</label>
                                                        <input class="form-control"
                                                               :class="{'is-invalid': p.$form.hasErrors('address.postal_code')}"
                                                               :required="p.$form.isRequired('address.postal_code')"
                                                               type="text"
                                                               v-model="p.address.postal_code">
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('address.postal_code')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                              <div class="form-row" v-if="!regData.hide_fields.hide_reg_address">
                                                    <div class="form-group col-12">
                                                        <label class="field-label">{{ $t('Riik') }}</label>
                                                        <select class="form-control"
                                                                :class="{'is-invalid': p.$form.hasErrors('address.country')}"
                                                                :required="p.$form.isRequired('address.country')"
                                                                v-model="p.address.country">
                                                            <option v-for="(v,k) in p.$form.fields.address.country._choices" :value="k">
                                                                {{ v }}
                                                            </option>
                                                        </select>
                                                        <div class="invalid-feedback" v-for="error in p.$form.getErrors('address.country')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="row action-btn-row">
                                        <div class="col-10 p-0">
                                            <button class="btn btn-success action-btn" v-on:click="savePrt(p.id)">
                                                {{ $t('Kinnitan osavõtja andmed') }}
                                            </button>

                                            <p v-for="successMessage in notificationsParticipant.successes" class="text-success my-2">
                                                {{ successMessage }}
                                            </p>
                                            <p v-for="errorMessage in notificationsParticipant.errors" class="text-danger my-2">
                                                {{ errorMessage }}
                                            </p>
                                        </div>
                                        <div class="col-2">
                                            <button class="btn btn-outline-danger border-0" :title="$t('Eemaldan osaleja')" v-on:click="remove(p.id)">
                                                <i class="fa fa-2x fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row form-section-header mt-4">
                <div class="col-12">
                    <h4 class="form-section-header-title">{{ $t('Lisad') }}</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 form pt-0">
                    <form action="#">
                      <div class="form-row" v-if="!regData.all_real_competitions && !regData.hide_fields.hide_reg_parcel_machine">
                            <div class="form-group col-12">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="form-check">
                                            <input class="form-check-input"
                                                   type="checkbox"
                                                   :class="{'is-invalid': regForm.hasErrors('parcel_machine')}"
                                                   :required="regForm.isRequired('parcel_machine')"
                                                   v-model="regData.parcel_machine">
                                            <label class="form-check-label">
                                                {{ $t('Soovin medalit pakiautomaati') }}
                                            </label>
                                        </div>
                                        <div class="invalid-feedback" v-for="error in regForm.getErrors('parcel_machine')">
                                            <div class="alert alert-danger">{{ error }}</div>
                                        </div>
                                    </div>
                                    <div class="col-3 text-right">
                                        + {{ Filters.formatFloat(prices.parcel) }} €
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-12" v-if="regData.parcel_machine">
                                <label class="field-label">{{ $t('Pakiautomaadi nimetus') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': regForm.hasErrors('parcel_machine_name')}"
                                       :required="regForm.isRequired('parcel_machine_name')"
                                       type="text"
                                       v-model="regData.parcel_machine_name">
                                <div class="invalid-feedback" v-for="error in regForm.getErrors('parcel_machine_name')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>

                      <div class="form-row" v-if="!regData.all_real_competitions && !regData.hide_fields.hide_reg_medal_abroad">
                            <div class="form-group col-12">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="form-check">
                                            <input class="form-check-input"
                                                   type="checkbox"
                                                   :class="{'is-invalid': regForm.hasErrors('medal_abroad')}"
                                                   :required="regForm.isRequired('medal_abroad')"
                                                   v-model="regData.medal_abroad">
                                            <label class="form-check-label">
                                                {{ $t('Soovin medalit välismaale') }}
                                            </label>
                                        </div>
                                        <div class="invalid-feedback" v-for="error in regForm.getErrors('medal_abroad')">
                                            <div class="alert alert-danger">{{ error }}</div>
                                        </div>
                                    </div>
                                    <div class="col-3 text-right">
                                        + {{ Filters.formatFloat(prices.abroad) }} €
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-12">
                            <label class="field-label">{{ $t('Klubi/Tiim') }}</label>
                            <input class="form-control"
                                   :class="{'is-invalid': regForm.hasErrors('team')}"
                                   :required="regForm.isRequired('team')"
                                   type="text"
                                   v-model="regData.team">
                            <div class="invalid-feedback" v-for="error in regForm.getErrors('team')">
                              <div class="alert alert-danger">{{ error }}</div>
                            </div>
                          </div>
                          <div class="form-group col-12" v-if="!regData.hide_fields.hide_reg_discount_code">
                                <label class="field-label">{{ $t('Sooduskood') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': regForm.hasErrors('discount_code')}"
                                       :required="regForm.isRequired('discount_code')"
                                       type="text"
                                       v-model="regData.discount_code">
                                <div class="invalid-feedback" v-for="error in regForm.getErrors('discount_code')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Märkused') }}</label>
                                <textarea class="form-control"
                                          :class="{'is-invalid': regForm.hasErrors('notes')}"
                                          :required="regForm.isRequired('notes')"
                                          type="text"
                                          v-model="regData.notes"></textarea>
                                <div class="invalid-feedback" v-for="error in regForm.getErrors('notes')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row action-btn-row">
                <div class="col-12 p-0">
                    <button class="btn btn-success action-btn" v-on:click="save()">{{ $t('Edasi') }}</button>

                    <p v-for="successMessage in notifications.successes" class="text-success my-2">
                        {{ successMessage }}
                    </p>
                    <p v-for="errorMessage in notifications.errors" class="text-danger my-2">
                        {{ errorMessage }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Form from './../form';
import Filters from '../filters';
import MrtNotifications from '../mrt-notifications';

export default {
    name: 'participants',
    setup() {
        return {
            Filters
        };
    },
    data() {
        return {
            regData: {
              hide_fields: {}
            },
            regForm: new Form({}),
            prices: {},
            participants: [],
            self: {
                address: {}
            },
            seq: 0,
            _formRawTpl: null,
            notifications: new MrtNotifications(),
            notificationsParticipant: new MrtNotifications(),
            errorMessage: null,
            successMessage: null,
        };
    },
    mounted() {
        axios.get(Mrt.config.routes['account.eventRegister.step2-participants-get'])
            .then(
                (response) => {
                    this.participants = response.data.participants;
                    this._formRawTpl = response.data.form;
                    if (this.participants) {
                        let first = true;
                        this.participants.map((p) => {
                            p.$form = new Form(this._formRawTpl);
                            if (first) {
                                p.$active = true;
                                first = false;
                            }
                            return p;
                        });
                    }
                    this.self = response.data.self;
                    this.self.$form = new Form(this._formRawTpl);
                    this.regForm = new Form(response.data.regForm);
                    this.regData = response.data.regData;
                    this.prices = response.data.prices;
                }
            );
    },
    methods: {
        addSelf() {
            if (!this.self) {
                return;
            }

            this.self.$active = true;
            this.participants.push(this.self);
        },
        isAdded(id) {
            return this.participants.findIndex(item => item.id === id) > -1;
        },
        find(id) {
            return this.participants.find(item => item.id === id);
        },
        findIdx(id) {
            return this.participants.findIndex(item => item.id === id);
        },
        savedParticipantsCount() {
            return this.participants.filter(item => item.$saved).length;
        },
        canAddMoreParticipants() {
            if (this.regData.participants_type === 'single' && this.savedParticipantsCount() >= 1) {
                return false;
            }

            return !(this.regData.participants_type === 'multi' && this.savedParticipantsCount() >= 2);
        },
        toggle(id) {
            const p = this.find(id);
            if (p) {
                p.$active = !p.$active;
            }
        },
        addNew() {
            this.participants.push(
                {
                    id: --this.seq,
                    address: {},
                    $active: true,
                    $form: new Form(this._formRawTpl)
                }
            );
        },
        remove(id) {
            const pIdx = this.findIdx(id);
            if (pIdx === -1) {
                return;
            }

            // Not saved, remove from list
            if (id < 0) {
                this.participants.splice(pIdx, 1);
                return;
            }

            // Remove from DB
            axios.post(Mrt.config.routes['account.eventRegister.step2-participants-remove'], {id: id})
                .then(
                    (response) => {
                        if (response.data.status === 'success') {
                            this.participants.splice(pIdx, 1);
                        } else {
                            this.notificationsParticipant.error(this.$t('Ei õnnestunud osavõtjat eemaldada'));
                        }
                    }
                )
                .catch((err) => {
                    this.notificationsParticipant.error(this.$t('Ei õnnestunud osavõtjat eemaldada'));
                });
        },
        savePrt(id) {
            let pIdx = this.findIdx(id);
            if (pIdx === -1) {
                return;
            }

            axios.post(Mrt.config.routes['account.eventRegister.step2-participants-add'], _.omit(this.participants[pIdx], ['$form']))
                .then(
                    (response) => {
                        if (response.data.p) {
                            this.participants[pIdx] = response.data.p;
                            this.participants[pIdx].$saved = true;
                            this.participants[pIdx].$form = new Form(response.data.form);
                            if (this.participants[pIdx].$form.hasErrors()) {
                                this.notificationsParticipant.error(this.$t('Vormis on vead'));
                            } else {
                                this.notificationsParticipant.success(this.$t('Osaleja on salvestatud'));
                            }
                        }
                    }
                )
                .catch((err) => {
                    this.notificationsParticipant.error(this.$t('Ei õnnestunud salvestada'));
                });
        },
        save() {
            if (this.savedParticipantsCount() === 0) {
                this.notifications.error(this.$t('Palun lisa ja salvesta mõni osaleja'));
                return;
            }
            if (this.regData.participants_type === 'multi' && this.savedParticipantsCount() < 2) {
                this.notifications.error(this.$t('Palun lisa kaks osalejat'));
                return;
            }

            axios.post(Mrt.config.routes['account.eventRegister.step2-participants-save'], this.regData)
                .then(
                    (response) => {
                        this.regForm = new Form(response.data.regForm);
                        this.regData = response.data.regData;
                        if (this.regForm.hasErrors()) {
                            this.notifications.error(this.$t('Vormis on vead'));
                        } else {
                            this.notifications.success(this.$t('Osavõtt salvestatud. Teid suunatakse maksmise juurde...'));
                            window.location.href = Mrt.config.routes['account.eventRegister.step3-payment'];
                        }
                    }
                )
                .catch((err) => {
                    this.notifications.error(this.$t('Ei õnnestunud registreeringut salvestada'));
                });
        }
    }
};
</script>

<style scoped>

</style>
